<template>
    <div :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#f2f2f2', 'color' : data.impairedRegime ? '#000000' : '#333333'}" class="outer flex-col">
        <directory :route="$route"></directory>
        <h1 v-if="lang === 'ru'" :style="{ 'color': data.impairedRegime ? '#000000' : '#333333' }">О проекте</h1>
        <h1 v-if="lang === 'kk'" :style="{ 'color': data.impairedRegime ? '#000000' : '#333333' }">Жоба туралы</h1>
        <!-- <h3 v-if="lang === 'ru'" style="font-size: 22px;line-height: 25px;">Проект создан при финансовой и технической поддержке Фонда ООН в области народонаселения (ЮНФПА) в Казахстане</h3>
        <h3 v-if="lang === 'kk'" style="font-size: 22px;line-height: 25px;">Жоба БҰҰ-ның Қазақстандағы Халық қоныстану қорының (ЮНФПА) қаржылық және техникалық қолдауымен құрылды</h3> -->
        <!-- <div :style="{ 'color': '#ffffff', 'background' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#568357' }" class="top-box flex-col">
            <h5>Company name</h5>
            <p v-if="lang === 'ru'">Этот сайт для подростков, их родителей, молодёжи и специалистов: на этом портале их будет объединять общая тема… сексуальное и репродуктивное здоровье.</p>
            <p v-if="lang === 'kk'">Бұл сайт жасөспірімдерге, олардың ата-аналарына, жастарға және мамандарға арналған: бұл порталда оларды ортақ тақырып біріктіреді... жыныстық және репродуктивті денсаулық.</p>
        </div> -->
        <h3 v-if="lang === 'ru'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Почему был создан этот сайт?</h3>
        <h3 v-if="lang === 'kk'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Сайтты жасау себебіміз</h3>
        <p v-if="lang === 'ru'" >Молодость – это замечательный период в жизни, когда молодой человек познает самого себя, окружающий мир и учится жить. Но, как и везде, нужно быть вооруженным знаниями, чтобы преодолеть трудности и избежать проблем.</p>
        <p v-if="lang === 'ru'" >Реальная жизнь многих подростков и молодых людей – это незащищенные сексуальные связи, отсутствие здорового отношения к личности и телу противоположного пола, трудности в установлении отношений.</p>
        <p v-if="lang === 'ru'" >Исследования последних лет подтверждают это. Казахстанские подростки (15-19 лет) начинают половую жизнь, в среднем, в 16,5 лет и при этом 60% имеют 4 половых партнеров в течение года. Вместе с этим наши подростки не имеют правильных знаний о сексуальном и репродуктивном здоровье: абсолютное большинство подростков (91%) не знают о путях передачи ВИЧ-инфекции, более 60% подростков считают, что, если симптомы половых инфекций прошли без лечения, значит они вылечились, только треть (34,4%) знают, как правильно пользоваться презервативами.</p>
        <p v-if="lang === 'ru'" >В итоге, в нашей стране высокий уровень родов среди подростков (в 5-6 раз выше, чем в развитых странах), и каждый год увеличивается регистрация новых случаев ВИЧ среди подростков, инфицирование которых произошло через половой путь.</p>
        <p v-if="lang === 'ru'" >Мы можем сколько угодно «прятать голову в песок», и утверждать, что всё в порядке, но есть реальные подростки, молодые люди и их реальная жизнь.</p>
        <p v-if="lang === 'ru'" >Поэтому важно «по-честному» признать, что такова реальность и независимо от того, какие у нас моральные установки или религиозные принципы, нам нужно понимать реальную жизнь подростков и молодых людей и вооружить их необходимыми знаниями.</p>
        <p v-if="lang === 'kk'" >Жастық шақ – жас адамның өзі, қоршаған әлем туралы біліп, өмір сүруді үйренетін керемет кезең. Бірақ қиындықтарды еңсеру және мәселелердің алдын алу үшін білімді болу керек.</p>
        <p v-if="lang === 'kk'" >Көптеген жасөспірім мен жастардың шынайы өмір шындығы мынадай: қорғалмаған жыныстық қатынас, өзге жыныс өкіліне және оның тәніне дұрыс көзқарастың қалыптаспауы, қарым-қатынас орнатудағы қиындықтар.</p>
        <p v-if="lang === 'kk'" >Соңғы жылдардағы зерттеу нәтижелері де сөзімізді қуаттай түседі. Қазақстандық жасөспірімдер (15–19 жастағы) жыныстық қатынасты орта есеппен 16,5 жаста бастайды, олардың 60%-ында бір жыл ішінде 4 жыныстық жұп ауысып үлгереді. Оған қоса жасөспірімдер сексуалды-репродуктивті денсаулық туралы дұрыс білім алмаған: жасөспірімдердің басым көпшілігі (91%) АИТВ-ның жұғу жолдарын білмейді, жасөспірімдердің 60%-дан астамы жыныстық инфекциялардың белгілері симптомсыз өтсе, демек ауру емделгені деп санайды, олардың үштен бір бөлігі ғана (34,4%) мүшеқапты дұрыс қолдану тәсілін біледі.</p>
        <p v-if="lang === 'kk'" >Осының салдарынан біздің елде жасөспірімдер арасында босанудың жоғары деңгейі байқалады (дамыған елдермен салыстырғанда 5–6 есе жоғары) және жыл сайын жыныстық жолмен инфекция жұқтырған жасөспірімдер арасында жаңа АИТВ тіркелетін болды.</p>
        <p v-if="lang === 'kk'" >Иә, мұның бәріне «көзімізді жұма қарай» аламыз және бәрі дұрыс дей беруге де болады, бірақ одан жасөспірімдер, жастар және олардың шынайы өмірлік мәселелері жоғалып кетпейді.</p>
        <p v-if="lang === 'kk'" >Сондықтан, мұның ащы шындық екенін мойындай білу маңызды және моральдық немесе діни ұстанымдарымызға қарамастан, жасөспірімдер мен жастардың шынайы өмірін түсініп, оларға қажет білім беруіміз керек.</p>
        <h3 v-if="lang === 'ru'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Что мы предлагаем подросткам?</h3>
        <h3 v-if="lang === 'kk'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Жасөспірімдерге не ұсынамыз?</h3>
        <p v-if="lang === 'ru'">Этот сайт разрабатывался для того, чтобы вы смогли найти ответы по самым разным проблемам сексуального и репродуктивного здоровья. Вы также можете анонимно обратиться за помощью и, переписываясь с консультантом, открыто рассказать о ситуации, которая вас беспокоит. Вы можете обратиться со своими проблемами в чат-бот, задать вопросы онлайн, получить ответы в удобном для тебя формате, а для полноценного консультирования обратиться в ближайший Молодёжный центр здоровья (МЦЗ). Там каждому обратившемуся бесплатно будет оказана помощь и предоставлены ответы на важные вопросы о репродуктивном здоровье.</p>
        <p v-if="lang === 'kk'">Бұл сайт сексуалды-репродуктивті денсаулық мәселелеріне қатысты сауалдардың жауабын табуға көмектесу үшін жасалған. Оған қоса анонимді көмек сұрауға болады және кеңес берушімен хат алмасу арқылы өзіңізді мазалайтын жағдай туралы ашық айта аласыз. Проблемаларыңызды айтып чат-ботқа хабарласып, онлайн режимде сұрақ қоюға мүмкіндігіңіз бар, ол сауалға өзіңізге ыңғайлы форматта жауап ала аласыз. Толыққанды кеңес алу үшін жақын жердегі Жастар денсаулық орталығына (ЖДО) хабарласыңыз. Онда жүгінгендердің барлығы ақысыз көмек алады және репродуктивті денсаулыққа қатысты маңызды сұрақтарға жауап табады.</p>
        <h3 v-if="lang === 'ru'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Что мы предлагаем родителям?</h3>
        <h3 v-if="lang === 'kk'" :style="{ 'color': data.impairedRegime ? '#000000' : '#568357' }">Біз ата-аналарға не ұсынамыз?</h3>
        <p v-if="lang === 'ru'">Родители – первые воспитатели подростков. Но мы знаем, что родителям сложно поднимать эти темы в разговоре со своими детьми. Наши исследования показывают, что, родители понимают свою ответственность и долг перед ребенком в его воспитании порядочным и здоровым членом общества, но с другой стороны, признаются, что не всегда знают, или психологически не готовы говорить с ребенком о сексуальном и репродуктивном здоровье.</p>
        <p v-if="lang === 'ru'">На этом сайте вы можете прочитать статьи профессионалов: психолога, дерматовенеролога, гинеколога, уролога об особенностях физического и психологического развития подростков и молодежи и о том, как говорить со своими детьми о сексуальном и репродуктивном здоровье.</p>
        <p v-if="lang === 'ru'">Мы надеемся, что эти материалы помогут вам лучше понять своего ребенка и оказать ему помощь и поддержку, в которой он нуждаются.</p>
        <p v-if="lang === 'kk'">Ата-аналар – жасөспірімдердің алғашқы тәрбиешілері. Балаларымен әңгімелескенде ата-аналарға бұл тақырыптарды қозғау қиын екенін білеміз. Біздің зерттеуіміз көрсеткендей, ата-аналар өз баласын қоғамның лайықты және толыққанды мүшесі етіп тәрбиелеудегі өзінің жауапкершілігі мен парызын түсінеді. Алайда олар өз баласымен сексуалды-репродуктивті денсаулық туралы сөйлесуге психологиялық тұрғыдан дайын емес екенін немесе қалай сөйлесу керегін біле бермейтінін мойындайды.</p>
        <p v-if="lang === 'kk'">Бұл сайтта сіз кәсіби мамандардың: психолог, дерматовенеролог, гинеколог, урологтың жасөспірімдер мен жастардың физикалық-психологиялық даму ерекшеліктері, балаларыңызбен сексуалдық-репродуктивті денсаулық туралы қалай әңгімелесуге болатыны жөніндегі мақалаларды оқи аласыз.</p>
        <p v-if="lang === 'kk'">Бұл материалдар сізге балаңызды жақсырақ түсінуге көмектеседі және балаларға қажет көмек пен қолдауды қалай көрсетуге болатынын түсіндіріп береді деп үміттенеміз.</p>
        <p v-if="lang === 'kk'">Веб-сайт Дүниежүзілік денсаулық сақтау ұйымы, БҰҰ-ның Халық қоныстану қоры (ЮНФПА), БҰҰ-ның АИТВ/ЖИТС жөніндегі бірлескен бағдарламасы (ЮНЭЙДС) және БҰҰ Балалар қоры (ЮНИСЕФ) әзірлеген сексуалды-репродуктивті денсаулық туралы қазіргі заманғы білім мен ұсыныстар негізінде жасалған.</p>
        <p v-if="lang === 'ru'">
            <br>
            При создании сайта были использованы современные научно обоснованные знания и рекомендации о сексуальном и репродуктивном здоровье, разработанные Всемирной организацией здравоохранения, Фондом ООН в области народонаселения (ЮНФПА), Объединенной программы ООН по ВИЧ/СПИДу (ЮНЭЙДС), Детским фондом ООН (ЮНИСЕФ).
        </p>
        <p v-if="lang === 'kk'">
            <br>
            Веб-сайт Дүниежүзілік денсаулық сақтау ұйымы, БҰҰ-ның Халық қоныстану қоры (ЮНФПА), БҰҰ-ның АИТВ/ЖИТС жөніндегі бірлескен бағдарламасы (ЮНЭЙДС) және БҰҰ Балалар қоры (ЮНИСЕФ) әзірлеген сексуалды-репродуктивті денсаулық туралы қазіргі заманғы білім мен ұсыныстар негізінде жасалған.
        </p>
    </div>
</template>
<script>
export default {
    props: [ 'data' ],
    data(){
        return {
            lang: 'kk'
        }
    },
    created(){
        if( localStorage.getItem('xyzCustomLang') ){
			this.lang = localStorage.getItem('xyzCustomLang')
		}
    }
}
</script>
<style lang="scss" scoped>
    *{
        transition: all 0.6s ease;
    }
    h1, h3, h5, p, span, a, label{
        cursor: default;
        text-decoration: none;
        text-align: left;
        margin: 0;
    }
    .outer{
        padding: 30px 16% 148px 16%;
        h1{
            font-weight: 500;
            font-size: 34px;
            line-height: 45px;
            letter-spacing: 0.04em;
        }
        .top-box{
            margin: 30px 0 10px 0;
            border-radius: 10px;
            padding: 30px;
            h5{
                font-weight: bold;
                font-size: 28px;
                line-height: 25px;
                letter-spacing: 0.03em;
                color: #FFFFFF;
            }
            p{
                margin-top: 0px;
                font-weight: 500;
                font-size: 22px;
                line-height: 25px;
                letter-spacing: 0.03em;
                color: #FFFFFF;
            }
        }
        h3{
            margin-top: 40px;
            font-weight: 500;
            font-size: 34px;
            line-height: 45px;
            letter-spacing: 0.04em;
        }
        p{
            // text-indent: 40px;
            text-align: justify;
            margin-top: 20px;
            font-weight: 300;
            font-size: 22px;
            line-height: 25px;
            letter-spacing: 0.03em;
        }
    }
    @media only screen and (max-width: 1024px){
        .outer{
            padding: 30px 12% 148px 12%;
            h1{
                font-size: 28px;
                line-height: 38px;
            }
            .top-box{
                margin: 20px 0 10px 0;
                border-radius: 10px;
                padding: 20px;
                h5{
                    font-weight: bold;
                    font-size: 24px;
                    line-height: 25px;
                    letter-spacing: 0.03em;
                    color: #FFFFFF;
                }
                p{
                    margin-top: 0px;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 24px;
                    letter-spacing: 0.03em;
                    color: #FFFFFF;
                }
            }
            h3{
                margin-top: 30px;
                font-weight: 500;
                font-size: 26px;
                line-height: 45px;
                letter-spacing: 0.04em;
            }
            p{
                // text-indent: 40px;
                margin-top: 10px;
                font-weight: 300;
                font-size: 18px;
                line-height: 25px;
                letter-spacing: 0.03em;
            }
        }
    }
    @media only screen and (max-width: 720px){
        .outer{
            padding: 30px 6% 68px 6%;
            h1{
                font-size: 26px;
                line-height: 28px;
            }
            .top-box{
                margin: 20px 0 10px 0;
                border-radius: 10px;
                padding: 20px;
                h5{
                    font-weight: bold;
                    font-size: 20px;
                    line-height: 25px;
                    letter-spacing: 0.03em;
                    color: #FFFFFF;
                }
                p{
                    margin-top: 0px;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: 0.03em;
                    color: #FFFFFF;
                }
            }
            h3{
                margin-top: 20px;
                font-weight: 500;
                font-size: 20px !important;
                line-height: 24px !important;
                letter-spacing: 0.04em;
            }
            p{
                // text-indent: 40px;
                margin-top: 10px;
                font-weight: 300;
                font-size: 16px;
                line-height: 25px;
                letter-spacing: 0.03em;
            }
        }
    }
    @media only screen and (max-width: 480px){
        .outer{
            padding: 30px 4% 68px 4%;
        }
    }
</style>
